<ion-grid>
  <ion-text color="dark" class="ion-text-center">
    <h2 class="related-content-title">{{ data?.title }}</h2>
  </ion-text>
  <ion-row>
    <ng-template ngFor let-item [ngForOf]="data?.items | slice: 0:3" let-i="index">
      <ion-col size="12" size-md="4">
        <app-card [data]="item" [img]="{
            url: item.featuredImage,
            alt: item.title,
            width: imageSize[0],
            height: imageSize[1],
            aspectRatio: '16:9'
          }" [showType]="showType" [hideCategory]="hideCategory" class="card-boxed"></app-card>
      </ion-col>
    </ng-template>
  </ion-row>
</ion-grid>